import {
  CertificatesClient,
  CreateCertificateClient,
} from './certificate.client';
import { CertificateModel } from './certificate.model';
import { RequestHeader } from '../../services';

export const createCertificateClientProvider = async (
  studentCourseId: string
): Promise<CertificateModel> => {
  const response = await new CreateCertificateClient(studentCourseId).post();

  return response as unknown as Promise<CertificateModel>;
};

export const certificatesClientProvider = async (
  requestHeaders?: RequestHeader
): Promise<CertificateModel[]> => {
  const response = await new CertificatesClient(requestHeaders).get();

  return response as unknown as Promise<CertificateModel[]>;
};
